<template>
  <div class="data-input-dropdown-container">
    <div class="data-input-dropdown-label">{{ title }}</div>
    <div class="data-input-dropdown-cont">
      <div class="data-input-dropdown-search">
        <div ref="searchBox" :style="DisabledBackground" class="search-box">
          <input ref="searchInput" v-model.lazy="selected" class="search-input-text-dropdown" type="text"
            :placeholder="'Select ' + title" :disabled="ProductResults === undefined" @focus="$event.target.select()"
            @focusin="handleFocus" @blur="handleFocusOut" @select="true" @keyup="handleSearch()" />
          <div class="icon-holder">
            <img v-if="!IsUpArrow" class="dropdown-down-arrow" :src="DownArrow" />
            <img v-if="IsUpArrow" style="stroke: orange !important" class="dropdown-up-arrow" :src="DownArrow" />
          </div>
        </div>
        <div v-if="SearchIsShowing && ProductResults" ref="searchResults" class="search-results">
          <div v-for="result in getSearchResults" tabindex="0" class="search-result"
            @click="handleSearchResultClick(result, $event)">
            <div>{{ result.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usePipeStore } from '@/store/PipeStore';
import DownArrow from '../../assets/svg/SVG/down_arrow.svg';
export default {
  props: ['title', 'items', 'value', 'isDisabled'],
  data () {
    return {
      isUpArrow: false,
      searchIsShowing: false,
      products: this.$props.items,
    };
  },
  computed: {
    selected: {
      get () {
        return usePipeStore().getEditedPipe.desc;
      },
      set (newValue) {
        this.$emit('input', newValue);
      },
    },
    SearchIsShowing () {
      return this.searchIsShowing;
    },
    ProductResults () {
      return this.$props.items;
    },
    getSearchResults () {
      return this.products;
    },
    IsUpArrow () {
      return this.isUpArrow;
    },
    DownArrow () {
      return DownArrow;
    },
    DisabledBackground () {
      if (this.ProductResults === undefined) { return { 'background-color': '#F2F2F4' }; }
    },
  },
  methods: {
    // search methods
    handleFocus () {
      this.searchIsShowing = true;
      this.products = this.ProductResults;
      this.isUpArrow = true;
      this.$refs.searchBox.classList.add('focused');
    },
    handleSearch () {
      let searchTxt = event.target.value.toLowerCase();
      let productSpecs = this.$props.items;
      // get the matching products
      this.products = productSpecs.filter((product) => {
        return product.desc.toLowerCase().includes(searchTxt);
      });
      if (this.products.length > 0) {
        this.searchIsShowing = true;
      }
    },
    handleSearchResultClick (product, e) {
      this.selectedProduct = product;
      this.$emit('input', product);
      this.handleFocusOut(e);
    },
    handleFocusOut (e) {
      if (e.relatedTarget === null) {
        this.searchIsShowing = false;
      }
      this.isUpArrow = false;
      this.$refs.searchBox.classList.remove('focused');
    },
  },
};
</script>

<style scoped>
input {
  border: none;
}
input:active {
  border: none !important;
}
.data-input-dropdown-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
}
.data-input-dropdown-cont {
  height: 35px;
}
.search-input-text-dropdown .search-input-text-dropdown:active {
  border: none;
}
.search-input-text-dropdown:active .search-input-text-dropdown:focus {
  background-color: transparent !important;
  border: 0px;
}
.data-input-dropdown-label {
  width: 17%;
  font-size: 14px;
  min-width: 75px;
  font-weight: bold;
}
.dropdown-selection-container {
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width:200px;
  width: 100%;
  padding: 15px 0;
  cursor: pointer;
  border-bottom: 1px black solid;
}
.dropdown-selection-container:hover {
  background-color: #ededed;
}
.dropdown-option {
  padding: 15px 15px 15px 10px;
}
.dropdown-option:hover {
  background-color: #ccc;
  cursor: pointer;
}
.dropdown-up-arrow {
  rotate: 180deg;
  width: 100%;
}
.dropdown-down-arrow {
  rotate: 0deg;
  width: 100%;
}

/* search css */

.data-input-dropdown-search {
  flex: 1;
  height: 100%;
  width: 100%;
}
.search-input {
  width: 100%;
  height: 100%;
  border: none;
}
.search-input:focus,
.search-input:focus {
  outline: none;
}
.search-box {
  width: 100%;
  height: 100%;
  display: flex;
  border: 1px solid #b2b2b2;
  background-color: #ffffff;
}
.icon-holder {
  width: 12px;
  height: auto;
  margin: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-results {
  width: 200px;
  position: absolute;
  background-color: #e1e1e1;
  box-shadow: 6px 6px 17px -2px rgba(0, 0, 0, 0.18);
  z-index: 99999;
  max-height: 400px;
  overflow-y: auto;
}
.search-result {
  font-size: 15px;
  padding: 15px;
  background-color: white;
  cursor: pointer;
  border-bottom: 1px solid gray;
}
.search-result:hover {
  background-color: #efece0 !important;
}
.search-input:disabled {
  background-color: #f2f2f4;
}
@media only screen and (max-width: 900px) {
  .search-box {
    width: 100%;
  }
}
</style>
